import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import BranchRoutesAPI from '../../api/branchRoutes';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getBranchRoutes(_state) {
    // Position is the tiebreak the matcher itself uses, so the screen has to show the same
    // order the engine resolves in — otherwise two routes that overlap look interchangeable
    // here and are not.
    return [..._state.records].sort(
      (a, b) => a.position - b.position || a.id - b.id
    );
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getBranchRoutes({ commit }) {
    commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isFetching: true });
    try {
      const response = await BranchRoutesAPI.get();
      commit(types.SET_BRANCH_ROUTES, response.data.payload);
    } finally {
      commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createBranchRoute({ commit }, payload) {
    commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isCreating: true });
    try {
      const response = await BranchRoutesAPI.create({ branch_route: payload });
      commit(types.ADD_BRANCH_ROUTE, response.data.payload);
    } finally {
      commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isCreating: false });
    }
  },
  update: async function updateBranchRoute({ commit }, { id, ...payload }) {
    commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isUpdating: true });
    try {
      const response = await BranchRoutesAPI.update(id, {
        branch_route: payload,
      });
      commit(types.EDIT_BRANCH_ROUTE, response.data.payload);
    } finally {
      commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async function deleteBranchRoute({ commit }, id) {
    commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isDeleting: true });
    try {
      await BranchRoutesAPI.delete(id);
      commit(types.DELETE_BRANCH_ROUTE, id);
    } finally {
      commit(types.SET_BRANCH_ROUTE_UI_FLAG, { isDeleting: false });
    }
  },
  // Deliberately not stored: a dry run is a question, not state. Keeping it out of the store
  // means the answer cannot go stale behind a later edit.
  match: async function matchBranchRoute(_context, text) {
    const response = await BranchRoutesAPI.match(text);
    return response.data;
  },
};

export const mutations = {
  [types.SET_BRANCH_ROUTE_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_BRANCH_ROUTES]: MutationHelpers.set,
  [types.ADD_BRANCH_ROUTE]: MutationHelpers.create,
  [types.EDIT_BRANCH_ROUTE]: MutationHelpers.update,
  [types.DELETE_BRANCH_ROUTE]: MutationHelpers.destroy,
};

export default { namespaced: true, actions, state, getters, mutations };
